export class StockSubstitutionResultsDto {
  success: boolean;
  stats: StockSubstitutionStatsDto;
  message?: string;
}

export class StockSubstitutionMultipleResultsDto {
  [key: number] : StockSubstitutionResultsDto
  global: StockSubstitutionStatsDto
}

export class StockSubstitutionStatsDto {
  recipes: number;
  recipeDetails: number;
  modifiers: number;
  products: number;
}
